import { render, staticRenderFns } from "./MagenteFormHeader.vue?vue&type=template&id=13f37daa"
import script from "./MagenteFormHeader.vue?vue&type=script&lang=js"
export * from "./MagenteFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports